// Pseudo-localization: accent every letter and pad the string ~35% so layout
// can be stress-tested before (or instead of) real translation. Client-only,
// display-only — never saved. Brackets mark the string edges so truncation is
// obvious. Padding ratio echoes the layout-risk engine's expansion factors.
const MAP = {
    a: 'á', b: 'ƀ', c: 'ç', d: 'ð', e: 'é', f: 'ƒ', g: 'ǵ', h: 'ĥ', i: 'í',
    j: 'ĵ', k: 'ķ', l: 'ĺ', m: 'ɱ', n: 'ñ', o: 'ó', p: 'ƥ', q: 'ʠ', r: 'ŕ',
    s: 'š', t: 'ţ', u: 'ú', v: 'ṽ', w: 'ŵ', x: 'ẋ', y: 'ý', z: 'ž',
    A: 'Á', B: 'Ɓ', C: 'Ç', D: 'Ð', E: 'É', F: 'Ƒ', G: 'Ǵ', H: 'Ĥ', I: 'Í',
    J: 'Ĵ', K: 'Ķ', L: 'Ĺ', M: 'Ϻ', N: 'Ñ', O: 'Ó', P: 'Ƥ', Q: 'Ǫ', R: 'Ŕ',
    S: 'Š', T: 'Ţ', U: 'Ú', V: 'Ṽ', W: 'Ŵ', X: 'Ẋ', Y: 'Ý', Z: 'Ž',
};

const PAD = '· '; // visible filler that adds width without looking like real text

export function pseudoLocalize(text) {
    if (!text) return text;
    const accented = text.replace(/[a-zA-Z]/g, (ch) => MAP[ch] || ch);
    const padLen = Math.ceil(text.length * 0.35);
    const tail = PAD.repeat(Math.ceil(padLen / PAD.length)).slice(0, padLen);
    return `⟦${accented}${tail ? ` ${tail}` : ''}⟧`;
}
